export enum StoreActions {
  READ_SUCCESS = 'READ_SUCCESS',
  ERROR_ON_READ = 'ERROR_ON_READ',
  UPDATE_SUCCESS = 'UPDATE_SUCCESS',
  ERROR_ON_UPDATE = 'ERROR_ON_UPDATE',
  CLEAR_ERROR = 'CLEAR_ERROR',
  DELETE_SUCCESS = 'DELETE_SUCCESS',
  ERROR_ON_DELETE = 'ERROR_ON_DELETE',
}
